import axios from "axios";

export default {
    getPersonAccountMemberSettings: async (personId, companyId) => {
        const { data } = await axios.get(`/account_member/settings/${companyId}/${personId}`)

        return data
    },
    savePersonAccountMemberSettings: async (personId, companyId, payload) => {
        const { data } = await axios.post(`/account_member/settings/${companyId}/${personId}`, payload)

        return data
    }
}
